// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__9yyk0","title":"BackImages_title__3Pwwx","images":"BackImages_images__3rIam"};